import { ThunkResult } from 'store/store';
import {
    createApplicationContextFetchFailureAction,
    createApplicationContextFetchRequestAction,
    createApplicationContextFetchSuccessAction,
} from 'store/AppContext/applicationContextAction';
import { ApplicationsApi } from 'services/ApiService/ServiceBoard/ServiceBoardApi';
import { logError } from 'core/services/common/logging/logger';

export const GetApplicationContext = (): ThunkResult => {
    return async (dispatch) => {
        dispatch(createApplicationContextFetchRequestAction());
        try {
            const applicationContext = await ApplicationsApi.getContext();
            dispatch(createApplicationContextFetchSuccessAction(applicationContext));
        } catch (error: unknown) {
            logError(error);
            dispatch(createApplicationContextFetchFailureAction());
        }
    };
};
